"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nonconformityBes5Schema = exports.bes5DegerSchema = exports.UYGUNSUZLUK_TAKIP_ONEKI = exports.NONCONFORMITY_DURUM_ETIKETI = exports.UYGUNSUZLUK_DEGERLENDIRME_VARSAYILAN = void 0;
exports.uygunsuzlukYetkiListesiIhlali = uygunsuzlukYetkiListesiIhlali;
exports.uygunsuzlukDurumEtiketi = uygunsuzlukDurumEtiketi;
exports.bildirimKabi = bildirimKabi;
exports.puan5x5 = puan5x5;
const zod_1 = require("zod");
const shared_types_1 = require("@isg/shared-types");
/**
 * UYGUNSUZLUK / BULGU — KURAL KATMANI (Tur 2½a; Kapsam §24 + §24.1, U1-U12).
 *
 * ⚠️ BU DOSYADA "KAPALI MI" YÜKLEMİ YOKTUR ve bu bilinçlidir: kapanış
 * türetmesi olayınkiyle AYNI fonksiyondur (`incident.ts olayKapaliMi` —
 * DÖF ≥1 ∧ tümü kapalı). İkinci bir tanım yazmak, bir gün eklenen bir
 * şartın diğerine sessizce eklenmemesiyle §2.40'ın türetme arızasını geri
 * getirirdi.
 */
/**
 * U5 — DEĞERLENDİRENLER tenant liste anahtarının VARSAYILANI
 * (`olay_inceleme` deseninin birebir kardeşi; boş/eksik liste = varsayılan).
 *
 * ⚠️ TEKNİSYEN LİSTEDE YOKTUR ve olay listesinden farkı budur: uygunsuzluk
 * değerlendirmek bir RET ve TAŞIMA yetkisidir (kaydın kaderini belirler);
 * §24.1/5'in onaylı üçlüsü uzman + şirket yön. + lokasyon yön.'dir.
 */
exports.UYGUNSUZLUK_DEGERLENDIRME_VARSAYILAN = [
    'isg_specialist',
    'company_admin',
    'location_manager',
];
/**
 * TABAN KİLİT (olay U6 deseni): `viewer` hiçbir yazma listesine giremez;
 * `contractor_rep` de giremez — yüklenici personeli v1'de uygunsuzluk
 * AÇAMAZ (Kapsam §24/3 şerhi), değerlendiremez de.
 */
function uygunsuzlukYetkiListesiIhlali(liste) {
    for (const sapka of liste) {
        if (!shared_types_1.ROLE_TYPES.includes(sapka)) {
            return `Tanınmayan şapka: ${sapka}`;
        }
        if (sapka === 'viewer') {
            return 'İzleyici hiçbir yazma listesine eklenemez (salt-okunur genel kural)';
        }
        if (sapka === 'contractor_rep') {
            return ('Yüklenici temsilcisi uygunsuzluk değerlendiremez — ' +
                'yüklenici personeli v1 kapsamı dışındadır');
        }
    }
    return null;
}
/** Kullanıcıya görünen durum etiketleri (tr.ts alias'ı buradan okur). */
exports.NONCONFORMITY_DURUM_ETIKETI = {
    reported: 'Bildirildi',
    rejected: 'Reddedildi',
    moved: 'Taşındı',
};
/**
 * TÜRETİLMİŞ DURUM ETİKETİ — ekranın rozet metni (§24.1/4).
 * `reported` üçe ayrılır: DÖF yok → *Bildirildi* · açık DÖF var → *İşlemde* ·
 * tümü kapalı → *Kapalı*. Ret ve taşıma kendi adlarını taşır.
 * ⚠️ Sıra önemlidir: kapanış türetmesi (`kapali`) `acik === 0` ile birlikte
 * ancak `toplam >= 1` iken doğrudur — 0/0 AÇIK kalır.
 */
function uygunsuzlukDurumEtiketi(durum, dof) {
    if (durum !== 'reported')
        return exports.NONCONFORMITY_DURUM_ETIKETI[durum];
    if (dof.kapali)
        return 'Kapalı';
    if (dof.toplam > 0)
        return 'İşlemde';
    return 'Bildirildi';
}
/**
 * TÜR → KAP YÖNLENDİRMESİ (U8) — TEK YÜKLEM.
 *
 * Bildiren *"olay mı uygunsuzluk mu"* sorusuyla HİÇ karşılaşmaz; kapıyı
 * kaydın TÜRÜ seçer. Public QR yüzeyi ve iç "Yeni bildirim" ekranı AYNI
 * fonksiyonu çağırır — ikinci bir yönlendirme yazılırsa iki kanal zamanla
 * ayrışır ve fark kimseye görünmez.
 *
 * ⚠️ Girdi KÜTÜPHANE REF'idir, kalem id'si değil: müşteri kalemi (kütüphane
 * ref'i olmayan) OLAY tarafına düşer — ürünün tanıdığı iki tehlike türü
 * dışındaki her şey bir GERÇEKLEŞMEDİR (§24/2 sınır çizgisi).
 * ⚠️ `null` (tür yok) = uzmanın kaza kaydı → OLAY.
 */
function bildirimKabi(olayTuruKutuphaneRef, tehlikeliRefleri) {
    if (olayTuruKutuphaneRef === null)
        return 'olay';
    return tehlikeliRefleri.includes(olayTuruKutuphaneRef) ? 'uygunsuzluk' : 'olay';
}
/** Takip numarası öneki — olayda `OLY-`, uygunsuzlukta `UYG-`. */
exports.UYGUNSUZLUK_TAKIP_ONEKI = 'UYG-';
// ── 5x5 DEĞERLENDİRME (U13 — tur 11 / R3-c; Kapsam §24.1/13) ───────────────
/**
 * **BURASI 5x5'İN EVİDİR** (05.09.2026). Araç olay modülünde doğdu
 * (F3B·S1 — *"tehlikeli durum/davranış değerlendirmesi"*); U8 o içeriği
 * uygunsuzluk kabına aldığı ve tur 11 olayın değerlendirme akışını emekliye
 * ayırdığı için **kod da doğru kaba taşındı.** Olay tarafı bu iki ismi
 * buradan import eder ve yalnız **salt okunur tarihçe** için kullanır
 * (§16.8/9 revizyonu) — ikinci bir tanım YAZILMAZ.
 *
 * ⚠️ **KENDİ İÇİNDE KAPALI SİSTEM:** üç çarpanlı yöntem (Fine-Kinney) burada
 * SUNULMAZ ve tenant risk metodolojisiyle bağı YOKTUR. Risk değerlendirmesi
 * **metodolojik bir çalışmadır**, uygunsuzluk skoru **hızlı bir yargı** —
 * aynı adı taşımaları onları aynı yapmaz (§16.12/2 sınır şerhi, aynen).
 *
 * ⚠️ **SKOR BİR KAPI DEĞİLDİR.** Kapanış türetmesi (`olayKapaliMi`), ret ve
 * taşıma bu değerleri HİÇ okumaz; skor önceliklendirme ve raporlama
 * girdisidir.
 */
exports.bes5DegerSchema = zod_1.z.number().int().min(1).max(5);
/** PUAN TÜRETİLİR — servis/gövde parametresi YOKTUR. */
function puan5x5(olasilik, siddet) {
    return exports.bes5DegerSchema.parse(olasilik) * exports.bes5DegerSchema.parse(siddet);
}
/** Yazma gövdesi. (Olay tarafındaki ikiz şema `incidentBes5Schema` tur
 *  11'de SÖKÜLDÜ — o uç artık yok.) */
exports.nonconformityBes5Schema = zod_1.z.object({
    olasilik: exports.bes5DegerSchema,
    siddet: exports.bes5DegerSchema,
});
//# sourceMappingURL=nonconformity.js.map